<template>
  <div></div>
</template>

<script>
import api from '@/services/api';

export default {
  name: 'Logout',
  mounted() {
    api.logout().finally(() => {
      localStorage.removeItem('token');
      localStorage.removeItem('profile');
      this.$router.push({ name: 'Login' });
    });
  },
}
</script>